import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {SpotlightAction, SpotlightProvider} from "@mantine/spotlight";
import {Notifications} from "@mantine/notifications";
import {
    IconAddressBook,
    IconArticle,
    IconHome,
    IconSearch,
    IconSectionSign,
    IconUser
} from "@tabler/icons-react";

import {Sites} from "./sites/Sites";

import settings from "./settings.json";
import {ModalsProvider} from "@mantine/modals";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

function redirect(url: string){
    // eslint-disable-next-line no-restricted-globals
    history.pushState(null, "", url);
    window.dispatchEvent(new Event('popstate'));
}


const actions: SpotlightAction[] = [
    {
        title: 'Home',
        group: "Seiten",
        description: 'Übersicht über meine Artikel',
        onTrigger: () => redirect("/home"),
        icon: <IconHome size={"1.2rem"}/>,
    },
    {
        title: 'About',
        group: "Seiten",
        description: 'Über mich und mein Projekt',
        onTrigger: () => redirect("/about"),
        icon: <IconUser size={"1.2rem"}/>,
    },
    {
        title: "Kontakt",
        group: "Seiten",
        description: "Kontakt",
        onTrigger: () => redirect("/kontakt"),
        icon: <IconAddressBook size={"1.2rem"}/>,
    },
]

if (settings.impressum) {
    actions.push({
        title: "Impressum",
        group: "Seiten",
        description: "Impressum",
        onTrigger: () => redirect("/impressum"),
        icon: <IconSectionSign size={"1.2rem"}/>,
    })
}

// @ts-ignore
actions.push(...Object.entries(Sites).filter(([, value]) => value.type === "blog").map(([, value]) => {
    return {
        id: value.link,
        group: "Artikel",
        title: value.title,
        onTrigger: () => redirect(value.link),
        // @ts-ignore
        description: value.date.toLocaleDateString() + " - " + (value.description.substring(0, 50) + (value.description.length >= 50? " ...": "")),
        icon: <IconArticle size={"1.2rem"}/>,
    }
}))


root.render(
  <React.StrictMode>
      <SpotlightProvider
          actions={actions}
          highlightQuery={true}
          searchIcon={<IconSearch size={"1.2rem"}/>}
          searchPlaceholder={"Suchen ..."}
          transitionProps={{ duration: 300, transition: 'slide-down' }}
          nothingFoundMessage={"Keine Erbenisse"}
          limit={5}
      >
          <ModalsProvider>
              <Notifications position={"bottom-right"}/>
              <App />
          </ModalsProvider>
      </SpotlightProvider>
  </React.StrictMode>
);